export default __webpack_public_path__ + "static/media/about_background_right.ad66d547.png";